import { Flex, Progress, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStyles } from 'src/features/auth/styles'

import { QR_PANEL_STATUS } from './constants'
import type { QrPanelState } from './types'

const { Text } = Typography

type QrWaitingStatusProps = {
  status: QrPanelState['status']
  progressPercent: number
  secondsRemaining: number
}

export const QrWaitingStatus = ({
  status,
  progressPercent,
  secondsRemaining
}: QrWaitingStatusProps) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  return (
    <Flex orientation="vertical" gap={10}>
      <Progress
        percent={progressPercent}
        showInfo={false}
        size="small"
        status={status === QR_PANEL_STATUS.SCANNED ? 'active' : 'normal'}
      />
      <Text type="secondary" className={styles.qrStatusText}>
        {status === QR_PANEL_STATUS.SCANNED
          ? t(`auth.qrSignIn.${QR_PANEL_STATUS.SCANNED}`)
          : t('auth.qrSignIn.waiting', { seconds: secondsRemaining })}
      </Text>
    </Flex>
  )
}
